import { Component, Fragment } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';

import { InvoiceService } from '../InvoiceService';
import { TenantCompanyService } from '../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';
import { InvoiceSettingDefaultService } from '../../he-thong/cau-hinh-hoa-don/InvoiceSettingDefaultService';
import { TaxService } from '../../danh-muc/thue-suat/TaxService';
import { TenantSettingService } from '../../he-thong/tham-so-he-thong/TenantSettingService';

import { AppStorage } from '../../../service/UserStorage';

import { ToastService } from '../../../AppToast';

import { InvoiceField } from '../item/Initial';
import { Input } from '../item/Input';
import { ChiTietHangHoa } from '../item/ChiTietHangHoa';
import { AmountToWord } from '../../../service/AmountToWord';

import { FormatDisplay } from '../../../shared/format';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialogService } from '../../../AppConfirmDialog';

export class DialogCrup extends Component<any, any> {

  private tenantCompany;
  private invoiceGroup;
  private invoiceSettings;
  private emptyItem;
  private formulas;
  private taxes;

  protected onewayCalc;

  private draft;

  private totalAmountSetting;

  private tenantSetting = {};

  private defaultTax;

  constructor(props) {
    super(props);

    this.state = {
      displayBasic: false,
      windowHeight: window.innerHeight,
      submitting: false,
      invoiceGroupSetting: null,
      item: {},
      validators: {},
      relatedInvoiceDetail: null,
      displayDraft: false,
      invoiceType: null,
      invoiceTypeName: '',
      dialogConfirm: {
        visible: false,
        message: ''
      }
    };

    this.onShow = this.onShow.bind(this);
    this.getFormat = this.getFormat.bind(this);
    this.patchItem = this.patchItem.bind(this);
    this.preview = this.preview.bind(this);
    this.onDraftShow = this.onDraftShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      this.tenantCompany = data;
    });
    InvoiceSettingDefaultService.getGroupTypeCode().then(data => {
      this.invoiceGroup = {};
      Object.keys(data).forEach(key => {
        this.invoiceGroup[key] = { label: data[key] };
      });
    });
    TaxService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      this.taxes = items;
      this.loadDefaultTax();
    });
    TenantSettingService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      this.tenantSetting = {};
      items.forEach(item => {
        if (item.key) {
          this.tenantSetting[item.key] = item.value;
        }
      });
      this.loadDefaultTax();
    });
  }

  loadDefaultTax() {
    if (this.taxes && this.taxes.length && this.tenantSetting && this.tenantSetting[TenantSettingService.key.DEFAULT_THUE_SUAT_GTGT]) {
      this.taxes.forEach(tax => {
        if (tax.code === this.tenantSetting[TenantSettingService.key.DEFAULT_THUE_SUAT_GTGT]) {
          this.defaultTax = tax;
        }
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if (prevProps.registerInvoice !== this.props.registerInvoice) {
      if (this.props.registerInvoice && this.props.registerInvoice.id) {
        RegisterInvoiceService.getInvoiceSettings(this.props.registerInvoice.id).then(data => {
          this.invoiceSettings = data;
          this.makeEmptyItem();
          this.makeInvoiceGroupSetting();
        });
      }
    }
    if (prevState.item && this.state.item) {
      if (prevState.item.invoiceSerial !== this.state.item.invoiceSerial) {
        this.props.registerInvoices.forEach(ri => {
          if (ri.symbolCode === this.state.item.invoiceSerial) {
            if (ri.id === this.props.registerInvoice.id) {
              this.makeEmptyItem({ invoiceSerial: this.state.item.invoiceSerial });
              this.makeInvoiceGroupSetting();
            } else {
              RegisterInvoiceService.getInvoiceSettings(ri.id).then(data => {
                this.invoiceSettings = data;
                this.makeEmptyItem({ invoiceSerial: this.state.item.invoiceSerial });
                this.makeInvoiceGroupSetting();
              });
            }
          }
        });
      }
    }
  }

  getFormat(setting: any, _item?: any) {

    const item = _item ? _item : this.state.item;

    let maxFractionDigits = 0;
    if (setting && setting.typeFormat &&
      item && item[InvoiceField.CurrencyCode] && item[InvoiceField.CurrencyCode][setting.typeFormat]) {
      maxFractionDigits = item[InvoiceField.CurrencyCode][setting.typeFormat];
    }
    return maxFractionDigits;
  }

  makeEmptyItem(_default?: any) {
    this.emptyItem = { invoiceDetail: [] };
    let def_c = null;
    if (this.props.currencies) {
      this.props.currencies.forEach(c => {
        if (c.code === this.tenantSetting[TenantSettingService.key.DEFAULT_MA_TIEN_TE]) {
          def_c = c;
        }
      });
    }
    this.invoiceSettings.forEach(setting => {
      if ('05' !== setting.groupTypeCode) {
        let _emptyValue;

        switch (setting.fieldName) {
          case InvoiceField.InvoiceSerial:
            _emptyValue = this.props.registerInvoice.symbolCode;
            break;
          case InvoiceField.CurrencyCode:
            _emptyValue = def_c;
            break;
          case InvoiceField.paymentMethod:
            _emptyValue = this.tenantSetting[TenantSettingService.key.DEFAULT_HTTT];
            break;
          case InvoiceField.exchangeRate:
            _emptyValue = this.tenantSetting[TenantSettingService.key.DEFAULT_TY_GIA];
            break;
          case InvoiceField.InvoiceDate:
            _emptyValue = new Date();
            break;
          case InvoiceField.nonTaxZone:
            _emptyValue = 1 * this.tenantSetting[TenantSettingService.key.DEFAULT_KHU_PHI_THUE_QUAN];
            break;
          case InvoiceField.isDeductionNQ43:
            _emptyValue = this.tenantSetting[TenantSettingService.key.DEFAULT_GIAM_THUE_NQ43] === 'true';
            break;
          default:
            switch (setting.dataType) {
              case 'int32':
                _emptyValue = null;
                break;
              default:
                _emptyValue = '';
            }
        }

        this.emptyItem[setting.fieldName] = _emptyValue;
      }
    });

    if (this.tenantCompany) {
      this.emptyItem[InvoiceField.sellerTaxCode] = this.tenantCompany.taxCode || '';
      this.emptyItem[InvoiceField.sellerLegalName] = this.tenantCompany.name || '';
      this.emptyItem[InvoiceField.sellerAddress] = this.tenantCompany.address || '';
      this.emptyItem[InvoiceField.sellerEmail] = this.tenantCompany.email || '';
      this.emptyItem[InvoiceField.sellerTel] = this.tenantCompany.tel || '';
      this.emptyItem[InvoiceField.sellBankAccount] = this.tenantCompany.bankAccount || '';
      this.emptyItem[InvoiceField.sellerBankName] = this.tenantCompany.bankName || '';
      this.emptyItem[InvoiceField.sellerFax] = this.tenantCompany.fax || '';
      this.emptyItem[InvoiceField.sellerWebsite] = this.tenantCompany.webSite || '';
    }

    if (_default) {
      this.emptyItem = Object.assign(this.emptyItem, _default);
    }
    const _emptyItem = Object.assign({}, this.emptyItem);
    this.setState({ item: Object.assign(_emptyItem, this.state.item) });
  }

  makeInvoiceGroupSetting() {
    const invoiceGroupSetting: any = { ...this.invoiceGroup };
    this.formulas = [];
    Object.keys(invoiceGroupSetting).forEach(key => {
      invoiceGroupSetting[key].settings = [];
    });
    let invoiceTypeName;
    for (const setting of this.invoiceSettings) {

      switch (setting.fieldName) {
        case InvoiceField.CurrencyCode:
          setting.options = this.props.currencies;
          break;
        case InvoiceField.paymentMethod:
          setting.options = this.props.paymentTypes;
          break;
        case InvoiceField.InvoiceSerial:
          if (this.props.invoiceStatus) {
            const options = [];
            const invoiceType = this.state.invoiceType || this.props.registerInvoice.invoiceType;
            // eslint-disable-next-line no-loop-func
            this.props.registerInvoices.forEach(ri => {
              if (ri.invoiceType === invoiceType) {
                invoiceTypeName = ri.invoiceTypeName;
                options.push({ value: ri.symbolCode, label: ri.symbolCode });
              }
            });
            setting.options = options;
            setting.readOnly = true;
          } else {
            const invoiceType = this.state.invoiceType || this.props.registerInvoice.invoiceType;
            // eslint-disable-next-line no-loop-func
            this.props.registerInvoices.forEach(ri => {
              if (ri.invoiceType === invoiceType) {
                invoiceTypeName = ri.invoiceTypeName;
              }
            });
            setting.options = null;
            setting.readOnly = false;
          }
          break;
        case InvoiceField.relatedInvoiceProperty:
          setting.options = [
            { value: 1, label: 'Thay thế' },
            { value: 2, label: 'Điều chỉnh' }
          ];
          setting.readOnly = false;
          break;
        case InvoiceField.relatedInvoiceType:
          setting.options = [
            { value: 1, label: 'Hóa đơn điện tử NĐ123' },
            { value: 2, label: 'Hóa đơn xác thực QĐ1209' },
            { value: 3, label: 'Hóa đơn NĐ51' },
            { value: 4, label: 'Hóa đơn đặt in NĐ123' }
          ];
          break;
        case InvoiceField.totalAmount:
          if (setting.groupTypeCode === '06') {
            this.totalAmountSetting = setting;
          }
          break;
        case InvoiceField.nonTaxZone:
          setting.options = [
            { value: 1, label: 'Trong' },
            { value: 0, label: 'Ngoài' }
          ];
          break;
        case InvoiceField.isDeductionNQ43:
          setting.options = [
            { value: true, label: 'Có' },
            { value: false, label: 'Không' }
          ];
          break;
        case InvoiceField.vatRateOverRevenue:
          setting.options = [
            { value: 1, label: '1' },
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 5, label: '5' }
          ];
          break;
      }

      if (invoiceGroupSetting[setting.groupTypeCode]) {
        invoiceGroupSetting[setting.groupTypeCode].settings.push(setting);
        if (setting.formulas) {
          for (const formula of setting.formulas) {
            this.formulas.push({
              type: formula.formulaType,
              value: `${setting.groupTypeCode}.${setting.fieldName}`,
              from: formula.formulaBe,
              fromFe: formula.formulaFe,
              group: setting.groupTypeCode
            });
          }
        }
        if (typeof this.state.item[InvoiceField.isDeductionNQ43] === 'boolean'
          && [InvoiceField.vatRateOverRevenue, InvoiceField.totalVATDeduction].includes(setting.fieldName)) {
          setting.readOnly = this.state.item[InvoiceField.isDeductionNQ43];
        }
        if (typeof this.state.item[InvoiceField.isDeductionNQ43] === 'boolean'
          && [InvoiceField.vatRateOverRevenue].includes(setting.fieldName)) {
          setting.required = this.state.item[InvoiceField.isDeductionNQ43];
        }
      }
    }
    this.setState({ invoiceGroupSetting, invoiceTypeName });
  }

  onShow() {
    if (this.props.selectedItem && this.props.selectedItem.id) {
      if ([2, 3].includes(this.props.invoiceStatus)) {
        InvoiceService.getParentInvoice(this.props.selectedItem.id).then(data => {

          if (data[InvoiceField.CurrencyId]) {
            this.props.currencies.forEach(currency => {
              if (currency.id === data[InvoiceField.CurrencyId]) {
                data[InvoiceField.CurrencyCode] = currency;
              }
            });
          }
          if (data.invoiceDetail) {
            data.invoiceDetail.forEach((item, index) => {
              item._id = `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
              Object.keys(item).forEach(k => {
                this.invoiceSettings.forEach(setting => {
                  if (setting.groupTypeCode === '05' && setting.fieldName === k && setting.dataType === 'datetime' && item[k]) {
                    item[k] = new Date(item[k]);
                  }
                });
              });
              if (this.taxes) {
                this.taxes.forEach(tax => {
                  if (tax.code === item[InvoiceField.vATCode]) {
                    item[InvoiceField.vATCode] = tax;
                  }
                });
              }
            });
          }

          const item: any = {};
          Object.keys(data).forEach(k => {
            this.invoiceSettings.forEach(setting => {
              if (setting.groupTypeCode !== '05' && setting.fieldName === k && setting.dataType === 'datetime' && data[k]) {
                data[k] = new Date(data[k]);
              }
            });
            if (data[k] || data[k] === 0 || data[k] === false) {
              item[k] = data[k];
            } else {
              item[k] = '';
            }
          });
          let invoiceType;
          if (data.registerInvoiceId) {
            for (const ri of this.props.registerInvoices) {
              if (ri.id === data.registerInvoiceId) {
                invoiceType = ri.invoiceType;
                break;
              }
            }
          }
          this.setState({ relatedInvoiceDetail: item.invoiceDetail, invoiceType });
          item.invoiceDetail = [];
          this.invoiceSettings.forEach(setting => {
            if (setting.groupTypeCode === '06') {
              item[setting.fieldName] = this.emptyItem[setting.fieldName];
            }
          });

          // hoa don lien quan
          // item[InvoiceField.relatedTemplateCode] = item[InvoiceField.templateCode];
          // item[InvoiceField.relatedInvoiceSerial] = item[InvoiceField.InvoiceSerial];
          item[InvoiceField.relatedInvoiceDate] = item[InvoiceField.InvoiceDate];
          item[InvoiceField.relatedInvoiceNumber] = '' + item[InvoiceField.invoiceNumber];
          item[InvoiceField.relatedInvoiceProperty] = this.props.invoiceStatus === 2 ? 2 : 1;
          item[InvoiceField.relatedInvoiceType] = 1;
          item[InvoiceField.relatedInvoiceId] = item.id;
          item[InvoiceField.InvoiceDate] = new Date();
          delete item.id;

          this.makeInvoiceGroupSetting();
          this.setState({ item });
        });
      } else {
        let detail;
        switch (this.props.selectedItem.invoiceStatus) {
          case 2:
            // dieu chinh
            detail = InvoiceService.getAdjustment(this.props.selectedItem.id);
            this.props.setInvoiceStatus(2);
            break;
          case 3:
            // thay the
            detail = InvoiceService.getSubstitute(this.props.selectedItem.id);
            this.props.setInvoiceStatus(3);
            break;
          default:
            detail = InvoiceService.getDetail(this.props.selectedItem.id);
        }
        detail.then(data => {

          if (this.props.selectedItem.isClone) {
            data.invoiceDate = new Date();
            delete data.invoiceNote;
            delete data.relatedInvoiceDate;
            delete data.relatedInvoiceId;
            delete data.relatedInvoiceNumber;
            delete data.relatedInvoiceProperty;
            delete data.relatedInvoiceSerial;
            delete data.relatedInvoiceType;
            delete data.relatedTemplateCode;
            delete data.sendTaxStatus;
            delete data.taxAuthorityCode;
            delete data.sendEmail;
            delete data.securityNo;
            delete data.creatorName;
          }

          if (data[InvoiceField.CurrencyId]) {
            this.props.currencies.forEach(currency => {
              if (currency.id === data[InvoiceField.CurrencyId]) {
                data[InvoiceField.CurrencyCode] = currency;
              }
            });
          }
          if (data.invoiceDetail) {
            data.invoiceDetail.forEach((item, index) => {
              item._id = `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
              Object.keys(item).forEach(k => {
                this.invoiceSettings.forEach(setting => {
                  if (setting.groupTypeCode === '05' && setting.fieldName === k && setting.dataType === 'datetime' && item[k]) {
                    item[k] = new Date(item[k]);
                  }
                });
              });

              if (this.taxes) {
                this.taxes.forEach(tax => {
                  if (tax.code === item[InvoiceField.vATCode]) {
                    item[InvoiceField.vATCode] = tax;
                  }
                });
              }
            });
          }

          const item: any = {};
          Object.keys(data).forEach(k => {
            this.invoiceSettings.forEach(setting => {
              if (setting.groupTypeCode !== '05' && setting.fieldName === k && setting.dataType === 'datetime' && data[k]) {
                data[k] = new Date(data[k]);
              }
            });
            if (data[k] || data[k] === 0 || data[k] === false) {
              item[k] = data[k];
            } else {
              item[k] = '';
            }
          });
          this.setState({ item, relatedInvoiceDetail: null });

          if (typeof item[InvoiceField.isDeductionNQ43] === 'boolean'
            && this.state.invoiceGroupSetting && this.state.invoiceGroupSetting['06']) {
            this.setState(prevState => {
              const invoiceGroupSetting = prevState.invoiceGroupSetting;
              invoiceGroupSetting['06'].settings.forEach(setting => {
                if ([InvoiceField.vatRateOverRevenue].includes(setting.fieldName)) {
                  setting.required = item[InvoiceField.isDeductionNQ43];
                }
                if ([InvoiceField.vatRateOverRevenue, InvoiceField.totalVATDeduction].includes(setting.fieldName)) {
                  setting.readOnly = item[InvoiceField.isDeductionNQ43];
                }
              });
              return ({
                invoiceGroupSetting: invoiceGroupSetting
              });
            });
          }
        });
      }
    } else {
      let invoiceType;
      const item = { ...this.emptyItem };
      if ([2, 3].includes(this.props.invoiceStatus)) {
        invoiceType = this.props.registerInvoice.invoiceType;

        item[InvoiceField.relatedInvoiceProperty] = this.props.invoiceStatus === 2 ? 2 : 1;
        item[InvoiceField.relatedInvoiceType] = 3;

        item[InvoiceField.InvoiceSerial] = this.props.registerInvoice.symbolCode;
      }
      this.setState({ item, relatedInvoiceDetail: null, invoiceType }, () => {
        this.makeInvoiceGroupSetting();
      });
    }
  }

  patchItem(group, field, value) {
    const _item = { ...this.state.item };

    switch (field) {
      case InvoiceField.relatedTemplateCode:
      case InvoiceField.relatedInvoiceSerial:
        _item[field] = value.toUpperCase();
        break;
      default:
        _item[field] = value;
    }

    switch (field) {
      case InvoiceField.CurrencyCode:
        if (value && value.id) {
          _item[InvoiceField.exchangeRate] = value.rate;
        }
        break;
      case InvoiceField.BuyerTaxCode:
      case InvoiceField.BuyerLegalName:
        if (value && value.buyerLegalName) {
          _item[InvoiceField.BuyerCode] = value.buyerCode || '';
          _item[InvoiceField.BuyerTaxCode] = value.buyerTaxCode || '';
          _item[InvoiceField.BuyerLegalName] = value.buyerLegalName || '';
          _item[InvoiceField.BuyerAddress] = value.buyerAddress || '';
          _item[InvoiceField.buyerEmail] = value.buyerEmail || '';
          _item[InvoiceField.buyerBankAccount] = value.buyerBankAccount || '';
          _item[InvoiceField.buyerBankName] = value.buyerBankName || '';
          _item[InvoiceField.buyerTel] = value.buyerTel || '';
          _item[InvoiceField.buyerDisplayName] = value.buyerDisplayName || '';
        }
        break;
      case InvoiceField.BuyerCode:
        if (value && value.id) {
          _item[InvoiceField.BuyerId] = value.id || '';
          _item[InvoiceField.BuyerCode] = value.code || '';
          _item[InvoiceField.BuyerTaxCode] = value.taxCode || '';
          _item[InvoiceField.BuyerLegalName] = value.name || '';
          _item[InvoiceField.buyerDisplayName] = value.personContact || '';
          _item[InvoiceField.BuyerAddress] = value.address || '';
          _item[InvoiceField.buyerEmail] = value.email || '';
          _item[InvoiceField.buyerBankAccount] = value.bankAccount || '';
          _item[InvoiceField.buyerBankName] = value.bankName || '';
          _item[InvoiceField.buyerTel] = value.mobile || '';
        }
        break;
      case InvoiceField.isDeductionNQ43:
        if (value === true) {
          this.setState(prevState => {
            const invoiceGroupSetting = prevState.invoiceGroupSetting;
            invoiceGroupSetting['06'].settings.forEach(setting => {
              if ([InvoiceField.vatRateOverRevenue].includes(setting.fieldName)) {
                setting.required = true;
              }
              if ([InvoiceField.vatRateOverRevenue, InvoiceField.totalVATDeduction].includes(setting.fieldName)) {
                setting.readOnly = true;
              }
            });
            return ({
              invoiceGroupSetting: invoiceGroupSetting
            });
          });
        } else if (value === false) {
          _item[InvoiceField.vatRateOverRevenue] = null;
          this.onValueChange(_item, '06', InvoiceField.vatRateOverRevenue, null);
          this.setState(prevState => {
            const invoiceGroupSetting = prevState.invoiceGroupSetting;
            invoiceGroupSetting['06'].settings.forEach(setting => {
              if ([InvoiceField.vatRateOverRevenue].includes(setting.fieldName)) {
                setting.required = false;
              }
              if ([InvoiceField.vatRateOverRevenue, InvoiceField.totalVATDeduction].includes(setting.fieldName)) {
                setting.readOnly = false;
              }
            });
            return ({
              invoiceGroupSetting: invoiceGroupSetting
            });
          });
        }
        break;
    }

    this.onewayCalc = {};
    this.onValueChange(_item, group, field, value);

    if (field !== InvoiceField.totalAmountToWord &&
      typeof _item[InvoiceField.totalAmount] === 'number' &&
      _item[InvoiceField.CurrencyCode] && _item[InvoiceField.CurrencyCode].code) {
      const _totalAmount = _item[InvoiceField.totalAmount].toFixed(this.getFormat(this.totalAmountSetting, _item));
      _item[InvoiceField.totalAmountToWord] = AmountToWord.DocTienBangChu(_totalAmount, _item[InvoiceField.CurrencyCode].code, {
        readCurrency: _item[InvoiceField.CurrencyCode].readCurrency,
        readDecimal: _item[InvoiceField.CurrencyCode].readDecimal
      });
      // _item[InvoiceField.totalAmountToWord] = AmountToWord.DocTienBangChu(_totalAmount, _item[InvoiceField.CurrencyCode].code);
    }

    this.setState({
      item: _item
    });
    this.validateField(field, value);
  }

  hasParams(formula, group, field) {
    if (formula.group !== '05' && formula.fromFe) {
      for (let entry of JSON.parse(formula.fromFe)) {
        // console.log(entry, group, field);
        if (field === 'invoiceDetail') {
          // console.log(group, field);
          if (entry.type === 'parameter' && entry.groupTypeCode === group) {
            return true;
          }
        } else {
          if (entry.type === 'parameter' && entry.groupTypeCode === group && entry.fieldName === field) {
            return true;
          }
        }
      }
    }
    return false;
  }

  onValueChange(_item, group, field, value) {
    if (!this.onewayCalc[field]) {
      this.onewayCalc[field] = 0;
    }
    if (this.onewayCalc[field] < 50) {
      this.onewayCalc[field]++;
      for (const formula of this.formulas) {
        if (this.hasParams(formula, group, field)) {
          let statement = '';
          try {

            const ROUND = a => {
              for (const setting of this.invoiceSettings) {
                if (setting.fieldName === formula.value.split('.')[1] && setting.groupTypeCode === formula.value.split('.')[0]) {
                  const fractionDigits = this.getFormat(setting);
                  a = parseFloat(parseFloat(a).toFixed(fractionDigits));
                }
              }
              return a;
            }

            let sumType = 0, sumStart = false, sumCondition = '';
            for (let entry of JSON.parse(formula.fromFe)) {
              if (entry.type === 'parameter') {
                if (sumStart) {
                  let val = 0;
                  if (_item.invoiceDetail) {
                    for (const prd of _item.invoiceDetail) {
                      if (typeof prd[entry.fieldName] === 'number') {

                        switch (sumType) {
                          case 1:
                            if (prd.property === 1) {
                              val += prd[entry.fieldName];
                            } else if (prd.property === 3) {
                              val += prd[entry.fieldName] * -1;
                            }
                            break;
                          case 2:
                            let condition = sumCondition.split(' ');
                            // eslint-disable-next-line no-eval
                            if (condition.length === 3 && eval(`${prd[condition[0]]}
														${condition[1]}
														${condition[2]}`)) {
                              if (prd.property === 1) {
                                val += prd[entry.fieldName];
                              } else if (prd.property === 3) {
                                val += prd[entry.fieldName] * -1;
                              }
                            }
                            break;
                        }
                      }
                    }
                  }
                  statement += val;
                } else if (entry.fieldName === field) {
                  statement += value || 0;
                } else {
                  statement += _item[entry.fieldName] || 0;
                }

              } else if (entry.type === 'operator' && entry.value === 'SUM') {
                sumType = 1;
              } else if (entry.type === 'operator' && entry.value === 'SUMIF') {
                sumType = 2;
              } else {
                if (entry.type === 'value' && sumType === 2 && sumStart) {
                  sumCondition = entry.value;
                } else {
                  statement += entry.value;
                }
                if (sumType && entry.type === 'operator') {
                  if (entry.value === '(') {
                    sumStart = true;
                  }
                  if (entry.value === ')') {
                    sumStart = false;
                  }
                }
              }
            }
            // console.log(formula, statement);
            // eslint-disable-next-line no-eval
            let result = eval(statement);
            if (typeof result === 'number') {
              if (!Number.isFinite(result) || Number.isNaN(result)) {
                result = 0;
              }
              if (`${result}`.length > 2 && `${result}`.split('.').length) {
                result = 1 * result.toPrecision(`${result}`.split('.')[0].length + 7);
              }
              _item[formula.value.split('.')[1]] = result;
              this.onValueChange(_item, formula.value.split('.')[0], formula.value.split('.')[1], result);
            }
          } catch (e) {
            console.log(statement, e);
          }
        }
      }
    }
  }

  validateField(field, value) {
    this.setState(prevState => {
      const validators = prevState.validators;
      validators[field] = '';
      for (const setting of this.invoiceSettings) {
        if (setting.fieldName === field) {
          if (field === InvoiceField.BuyerTaxCode) {
            if (value?.trim && value?.trim()) {
              if (!/^[0-9-]+$/.test(value.trim()) || value.length > 14) {
                validators[setting.fieldName] = 'MST không hợp lệ';
              }
            }
          }
          if (field === InvoiceField.buyerEmail) {
            value.split(/[;,]\s*/).forEach((email) => {
              if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email.trim())) {
                validators[setting.fieldName] = 'Email không hợp lệ';
              }
            });
          }
          switch (setting.dataType) {
            case 'int32':
              if (setting.required === true && isNaN(parseFloat(value))) {
                validators[setting.fieldName] = 'Trường bắt buộc';
              }
              break;
            default:
              if (setting.required === true) {
                if (value === '' || value === undefined) {
                  validators[setting.fieldName] = 'Trường bắt buộc';
                }
              }
          }
        }
      }
      if (!validators[field]) {
        validators[field] = this.validateSetting04(field, value);
      }
      return ({
        validators: validators
      });
    });
  }

  validateSetting04(field, value) {
    let validate = '';
    if (value && this.state.item && [2, 3].includes(this.props.invoiceStatus)) {
      switch (field) {
        case InvoiceField.relatedTemplateCode:
          if (this.state.item[InvoiceField.relatedInvoiceType] === 1) {
            if (!(value.length === 1 && parseInt(value) >= 1 && parseInt(value) <= 6)) {
              validate = 'Mẫu số hóa đơn chỉ được nhập giá trị từ 1 đến 6';
            }
          } else {
            if (value.length !== 11) {
              validate = 'Độ dài ký hiệu hóa đơn liên quan không hợp lệ.';
            } else if (value.length >= 2 && !['01', '02', '03', '04'].includes(`${value[0]}${value[1]}`)) {
              validate = 'Hai ký tự đầu về loại hóa đơn không hợp lệ';
            } else if (value.length >= 6 && !['GTKT', 'GTTT', 'XKNB', 'HGDL'].includes(`${value[2]}${value[3]}${value[4]}${value[5]}`.toUpperCase())) {
              validate = 'Bốn ký tự loại hóa đơn không hợp lệ';
            } else if (value.length >= 7 && !['0', '1', '2', '3'].includes(value[6])) {
              validate = 'Ký tự số liên không hợp lệ';
            } else if (value.length >= 8 && !['/'].includes(value[7])) {
              validate = 'Ký tự phân cách trong ký hiệu không hợp lệ';
            } else if (value.length >= 11 && !['001', '002', '003'].includes(`${value[8]}${value[9]}${value[10]}`)) {
              validate = 'Ba ký tự lần phát hành không hợp lệ';
            }
          }
          break;
        case InvoiceField.relatedInvoiceSerial:
          if (this.state.item[InvoiceField.relatedInvoiceType] === 1) {
            if (value.length !== 6) {
              validate = 'Độ dài ký hiệu hóa đơn liên quan không hợp lệ.';
            } else if (!['C', 'K'].includes(value[0].toUpperCase())) {
              validate = 'Ký tự hình thức hóa đơn không hợp lệ';
            } else if (value.length >= 3 && (Number.isNaN(parseInt(value[1])) || Number.isNaN(parseInt(value[2])))) {
              validate = 'Ký tự năm của ký hiệu không hợp lệ';
            } else if (value.length >= 4 && !['T', 'M', 'G', 'H', 'B', 'N'].includes(value[3].toUpperCase())) {
              validate = 'Ký tự loại hóa đơn không hợp lệ';
            }
          } else {
            if (value.length !== 6) {
              validate = 'Độ dài Ký hiệu hóa đơn không hợp lệ.';
            } else if (value.length >= 2 && (!/^[A-EG-HK-NP-TVXYZ]$/.test(value[0].toUpperCase()) || !/^[A-EG-HK-NP-TVXYZ]$/.test(value[1].toUpperCase()))) {
              validate = 'Hai ký tự đầu không hợp lệ';
            } else if (value.length >= 3 && !['/'].includes(value[2])) {
              validate = 'Ký tự phân cách không hợp lệ';
            } else if (value.length >= 5 && (Number.isNaN(parseInt(value[3])) || Number.isNaN(parseInt(value[4])))) {
              validate = 'Ký tự năm phát hành không hợp lệ';
            } else if (value.length === 6 && !['E', 'P', 'T'].includes(value[5].toUpperCase())) {
              validate = 'Ký tự loại hình hóa đơn không hợp lệ';
            }
          }
          break;
        case InvoiceField.relatedInvoiceDate:
          if (value) {
            if (new Date(value) > new Date()) {
              validate = 'Ngày hóa đơn có liên quan không được lớn hơn ngày hiện tại';
            }
          }
          break;
      }
    }
    return validate;
  }

  validateTaxCode(value) {
    let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
    if (value.length > 10) {
      patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
    }
    if (value === "") return true;
    if (patt.test(value) === false) {
      return false;
    }
    const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
      + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
      + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

    return (10 - number % 11) === Number(value.charAt(9));
  }

  validate() {
    if (this.state.item.invoiceDetail && this.state.item.invoiceDetail.length) {
      let validators = {}, valid = true;

      if (this.state.item[InvoiceField.BuyerTaxCode] && !this.validateTaxCode(this.state.item[InvoiceField.BuyerTaxCode])) {
        ToastService.error(`Mã số thuế bên mua không hợp lệ`);
        return false;
      }

      for (const setting of this.invoiceSettings) {
        if (setting.groupTypeCode === '05') {
          if (setting.required) {
            for (const x of this.state.item.invoiceDetail) {

              if (x[InvoiceField.property] === 4) {
                if (setting.fieldName === InvoiceField.ProductName && !x[setting.fieldName]) {
                  ToastService.error(`Danh sách hàng hóa: Trường ${setting.lable} không được để trống`);
                  valid = false;
                  return false;
                }
              } else {
                if (setting.fieldName === InvoiceField.vATCode) {
                  if (!x[setting.fieldName]) {
                    ToastService.error(`Danh sách hàng hóa: Trường ${setting.lable} không được để trống`);
                    valid = false;
                    return false;
                  }
                } else {
                  switch (setting.dataType) {
                    case 'int32':
                      if (isNaN(parseFloat(x[setting.fieldName]))) {
                        ToastService.error(`Danh sách hàng hóa: Trường ${setting.lable} không được để trống`);
                        valid = false;
                        return false;
                      }
                      break;
                    default:
                      if (!x[setting.fieldName]) {
                        ToastService.error(`Danh sách hàng hóa: Trường ${setting.lable} không được để trống`);
                        valid = false;
                        return false;
                      }
                  }
                }
              }
            }
          }
          continue;
        }
        if (!this.props.invoiceStatus && setting.groupTypeCode === '04') {
          continue;
        }
        if (setting.required) {
          switch (setting.dataType) {
            case 'int32':
              if (isNaN(parseFloat(this.state.item[setting.fieldName]))) {
                valid = false;
                validators[setting.fieldName] = 'Trường bắt buộc';
              }
              break;
            default:
              if (this.state.item[setting.fieldName] === undefined || this.state.item[setting.fieldName] === '') {
                valid = false;
                validators[setting.fieldName] = 'Trường bắt buộc';
              }
          }
        }
        if (!validators[setting.fieldName]) {
          validators[setting.fieldName] = this.validateSetting04(setting.fieldName, this.state.item[setting.fieldName]);
          if (validators[setting.fieldName]) {
            valid = false;
          }
        }
      }
      this.setState({ validators });
      return valid;
    } else {
      ToastService.error('Danh sách hàng hóa trống');
      return false;
    }
  }

  getData(): any {
    if (this.validate()) {
      const data: any = {}, _data = Object.assign({}, this.state.item);
      Object.keys(_data).forEach(k => {
        if (_data[k] === '') {
          _data[k] = null;
        }
        data[k] = _data[k];
      });
      data.registerInvoiceId = this.props.registerInvoice.id;
      if ([2, 3].includes(this.props.invoiceStatus)) {
        this.props.registerInvoices.forEach(ri => {
          if (ri.symbolCode === data[InvoiceField.InvoiceSerial]) {
            data.registerInvoiceId = ri.id;
          }
        });
      }
      if (data[InvoiceField.CurrencyCode] && data[InvoiceField.CurrencyCode].id) {
        data[InvoiceField.CurrencyId] = data[InvoiceField.CurrencyCode].id;
        data[InvoiceField.CurrencyCode] = data[InvoiceField.CurrencyCode].code;
      }
      if (data[InvoiceField.BuyerCode] && data[InvoiceField.BuyerCode].id) {
        data[InvoiceField.BuyerId] = data[InvoiceField.BuyerCode].id;
        data[InvoiceField.BuyerCode] = data[InvoiceField.BuyerCode].code;
      }
      const invoiceDetail = [];
      data.invoiceDetail.forEach(x => {
        const i: any = Object.assign({}, x)
        if (i[InvoiceField.ProductName]) {
          if (i[InvoiceField.ProductCode] && i[InvoiceField.ProductCode].id) {
            i[InvoiceField.ProductId] = i[InvoiceField.ProductCode].id;
            i[InvoiceField.ProductCode] = i[InvoiceField.ProductCode].code;
          }
          if (i[InvoiceField.vATCode] && i[InvoiceField.vATCode].code) {
            i[InvoiceField.vATId] = i[InvoiceField.vATCode].id;
            i[InvoiceField.vATCode] = i[InvoiceField.vATCode].code;
            i[InvoiceField.VATRate] = i[InvoiceField.vATCode].code;
          }
          if (i[InvoiceField.unitCode] && i[InvoiceField.unitCode].value) {
            i[InvoiceField.unitCode] = i[InvoiceField.unitCode].value;
          }
          if (typeof i[InvoiceField.OrdinalNumber] === 'number') {
            i[InvoiceField.OrdinalNumber] = '' + i[InvoiceField.OrdinalNumber];
          }

          Object.keys(i).forEach(key => {
            if (i[key] instanceof Date) {
              i[key] = FormatDisplay.date(i[key], 'YYYY-MM-DD');
            }
          });

          const validI = {
            formulaType: i.formulaType,
            orders: i.orders,
            isShowOrder: i.isShowOrder,
            ordinalNumberManual: i.ordinalNumberManual
          };
          this.state.invoiceGroupSetting['05'].settings.forEach(setting => {
            validI[setting.fieldName] = i[setting.fieldName];
          });

          invoiceDetail.push(validI);
        }
      });
      data.invoiceDetail = invoiceDetail;
      data.invoiceStatus = this.props.invoiceStatus;

      Object.keys(data).forEach(key => {
        if (data[key] instanceof Date) {
          data[key] = FormatDisplay.date(data[key], 'YYYY-MM-DD');
        }
      });

      return data;
    } else {
      ToastService.error('Chưa điền đầy đủ các trường yêu cầu.');
    }
  }

  preview(): void {
    const data = this.getData();
    if (data) {
      this.setState({ displayDraft: true });
    }
  }

  onDraftShow(): void {
    const data = this.getData();
    if (!this.state.submitting && data) {
      this.setState({ submitting: true });

      InvoiceService.printViewDraft(data).then(res => {

        let html = '';
        res.pagehmtl.forEach(page => {
          html += page.trim();
        });

        this.draft.contentWindow.document.open();
        this.draft.contentWindow.document.write(html);
      }).finally(() => {
        this.setState({ submitting: false })
      });
    }
  }

  handleAlert(sign?: boolean) {
    const data = this.getData();
    const invoiceSerial = this.state.item.invoiceSerial
    const invoiceSerialValue = invoiceSerial[0];
    if (this.props.registerInvoice.typeCompany !== 1 && !this.props.invoiceStatus && invoiceSerialValue === '1') {
      const invalidAmounts = data.invoiceDetail.filter(item => {
        const calculatedAmount = item.quantity * item.unitPrice;
        return calculatedAmount !== 0 && Math.abs(calculatedAmount - item.amount) > 10;
      });

      const sumAmountWithoutVAT = data.invoiceDetail.reduce((sum, item) => {

        switch (item.property) {
          case 3: return sum - item.amountWithoutVAT;
          case 2:
          case 4: return sum;
          default: return sum + item.amountWithoutVAT;
        }
      }, 0);

      //invoiceDetail <>
      if (invalidAmounts.length) {
        return ConfirmDialogService.alert(
          'Thông báo',
          invalidAmounts.map(item => {
            const difference = Math.abs(item.quantity * item.unitPrice - item.amount);
            return <p>Mặt hàng {item.productName} tại dòng <b>{item.ordinalNumber}</b> có Số lượng x Đơn giá khác Thành tiền; chênh lệch <b>{FormatDisplay.number(difference)}</b></p>;
          }),
          () => this.handleSubmit(sign)
        )
      }

      //Tiền trước thuế=Tổng tiền chưa thuế 
      if (!(sumAmountWithoutVAT === data.totalAmountWithoutVAT)) {
        return ConfirmDialogService.alert(
          'Thông báo',
          <p>Tổng tiền trước thuế Chi tiết <b>{FormatDisplay.number(sumAmountWithoutVAT)}</b> khác với tổng tiền trước thuế Đầu phiếu <b>{FormatDisplay.number(data.totalAmountWithoutVAT)}</b>; chênh lệch <b>{FormatDisplay.number(Math.abs(sumAmountWithoutVAT - data.totalAmountWithoutVAT))}</b></p>,
          () => this.handleSubmit(sign)
        )

      }
      //Tổng tiền chưa thuế+Tổng tiền thuế=Tổng tiền thanh toán
      if (!(data.totalAmountWithoutVAT + data.vatAmount === data.totalAmount)) {
        return ConfirmDialogService.alert(
          'Thông báo',
          <p>Tổng tiền trước thuế <b>{FormatDisplay.number(data.totalAmountWithoutVAT)}</b> + Tổng tiền thuế <b>{FormatDisplay.number(data.vatAmount)}</b> khác với Tổng tiền thanh toán <b>{FormatDisplay.number(data.totalAmount)}</b>; chênh lệch <b>{FormatDisplay.number(Math.abs(data.totalAmountWithoutVAT + data.vatAmount - data.totalAmount))}</b></p>,
          () => this.handleSubmit(sign)
        )
      }
    }
    this.handleSubmit(sign)
  }

  handleSubmit(sign?: boolean) {
    const data = this.getData();
    if (!this.state.submitting && data) {
      this.setState({ submitting: true });

      let method;
      switch (this.props.invoiceStatus) {
        case 2:
          // dieu chinh
          if (data.id) {
            method = InvoiceService.updateAdjustment(data.id, data);
          } else {
            method = InvoiceService.createAdjustment(data);
          }
          break;
        case 3:
          // thay the
          if (data.id) {
            method = InvoiceService.updateSubstitute(data.id, data);
          } else {
            method = InvoiceService.createSubstitute(data);
          }
          break;
        default:
          if (data.id && !this.props.selectedItem.isClone) {
            method = InvoiceService.update(data.id, data);
          } else {
            delete data.id;
            method = InvoiceService.create(data);
          }
      }

      method.then((res) => {
        if (sign) {
          let InvoiceIdArray;
          if (res.id) {
            InvoiceIdArray = [res.id];
          } else {
            InvoiceIdArray = [data.id];
          }
          this.props.sign({
            "CommandName": "SignInvoices",
            "InvoiceIdArray": InvoiceIdArray
          });
          ToastService.success();
          this.props.setDisplay(false);
        } else {
          ToastService.success();
          this.props.setDisplay(false);
          this.props.reloadLazyData();
        }
      }).finally(() => {
        this.setState({ submitting: false })
      });
    }
  }

  render() {
    if (this.state.invoiceGroupSetting) {
      let _header;
      switch (this.props.invoiceStatus) {
        case 2:
          _header = 'Điều chỉnh';
          break
        case 3:
          _header = 'Thay thế';
          break
        default:
          if (this.props.selectedItem && this.props.selectedItem.id) {
            if (this.props.selectedItem.isClone) {
              _header = 'Sao chép';
            } else {
              _header = 'Chỉnh sửa';
            }
          } else {
            _header = 'Tạo mới';
          }
      }

      const footer = (
        <div className="flex justify-content-center">
          <Button label="Đóng" onClick={() => {
            this.props.setDisplay(false)
            this.setState({ validators: {} })
          }} className="p-button-outlined p-button-secondary p-button-sm mr-2" />
          <Button label="Xem trước" onClick={this.preview} loading={this.state.submitting} className="p-button-outlined p-button-success p-button-sm mr-2" />
          <Button label="Lưu" onClick={() => this.handleAlert()} loading={this.state.submitting} className="p-button-outlined p-button-sm mr-2" />
          {this.props.showIconSign &&
            <Button label="Lưu và ký" onClick={() => this.handleAlert(true)} loading={this.state.submitting} className="p-button-sm" />
          }
        </div>
      );

      return (
        <Fragment>
          <Dialog header={`${_header} ${this.state.invoiceTypeName}`} footer={footer} visible={this.props.display} maximized={true} onShow={this.onShow} onHide={() => {
            this.props.setDisplay(false)
            this.setState({ validators: {} })

          }}
            className="form-xs bg-theme crup-invoice">
            <div className="grid p-1">
              <div className={`col-12 p-1 ${this.state.invoiceGroupSetting['01'].settings.length ? 'md:col-2' : 'md:col-3'}`}>
                <Fieldset legend="Thông tin chung">
                  <div className="p-fluid grid">
                    {
                      this.state.invoiceGroupSetting['00'].settings.map((setting, index) => {
                        return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} />
                      })
                    }
                  </div>
                </Fieldset>
              </div>
              {!!this.state.invoiceGroupSetting['01'].settings.length &&
                <div className="col-12 md:col-5 p-1">
                  <Fieldset legend="Thông tin bên bán">
                    <div className="p-fluid grid">
                      {
                        this.state.invoiceGroupSetting['01'].settings.map((setting, index) => {
                          return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} />
                        })
                      }
                    </div>
                  </Fieldset>
                </div>
              }
              <div className={`col-12 p-1 ${this.state.invoiceGroupSetting['01'].settings.length ? 'md:col-5' : 'md:col-9'}`}>
                <Fieldset legend="Thông tin bên mua">
                  <div className="p-fluid grid">
                    {
                      this.state.invoiceGroupSetting['02'].settings.map((setting, index) => {
                        return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} />
                      })
                    }
                  </div>
                </Fieldset>
              </div>
              {(this.state.invoiceGroupSetting['04'].settings.length && [2, 3].includes(this.props.invoiceStatus)) &&
                <div className="col-12 p-1">
                  <Fieldset legend="Hóa đơn liên quan">
                    <div className="p-fluid grid">
                      {
                        this.state.invoiceGroupSetting['04'].settings.map((setting, index) => {
                          return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} />
                        })
                      }
                    </div>
                  </Fieldset>
                </div>
              }
              {!!this.state.invoiceGroupSetting['03'].settings.length &&
                <div className="col-12 p-1">
                  <Fieldset legend="Thông tin khác">
                    <div className="p-fluid grid">
                      {
                        this.state.invoiceGroupSetting['03'].settings.map((setting, index) => {
                          return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} />
                        })
                      }
                    </div>
                  </Fieldset>
                </div>
              }
              <div className="col-12 p-1">
                <ChiTietHangHoa invoiceGroupSetting={this.state.invoiceGroupSetting} formulas={this.formulas} item={this.state.item} taxes={this.taxes} defaultTax={this.defaultTax}
                  patchItem={this.patchItem} getFormat={this.getFormat}
                  invoiceStatus={this.props.invoiceStatus} relatedInvoiceDetail={this.state.relatedInvoiceDetail}
                  registerInvoiceId={this.props.registerInvoice.id} />
              </div>
              <div className="col-12 p-1">
                <Fieldset legend="Tổng cộng">
                  <div className="p-fluid grid">
                    {
                      this.state.invoiceGroupSetting['06'].settings.map((setting, index) => {
                        return <Input key={index} item={this.state.item} getFormat={this.getFormat} patchItem={this.patchItem} setting={setting} validators={this.state.validators} gridType="percent" />
                      })
                    }
                  </div>
                </Fieldset>
              </div>
            </div>
          </Dialog>
          <Dialog visible={this.state.displayDraft} style={{ width: '890px' }} draggable={false} resizable={true} position="top"
            onHide={() => this.setState({ displayDraft: false })} onShow={this.onDraftShow} className="view-invoice">
            <iframe className="template-preview" ref={(el) => this.draft = el} title="template-preview" />
          </Dialog>
          {/* <ConfirmDialog
            visible={this.state.dialogConfirm.visible}
            onHide={() => this.setState({ dialogConfirm: { ...this.state.dialogConfirm, visible: false } })}
            message={this.state.dialogConfirm.message}
            header="Thông báo"
            icon="pi pi-exclamation-triangle"
            accept={() => this.setState({ dialogConfirm: { ...this.state.dialogConfirm, visible: false } })}
            reject={() => this.setState({ dialogConfirm: { ...this.state.dialogConfirm, visible: false } })}
          /> */}
        </Fragment>
      );
    } else {
      return '';
    }
  }
}